export const handleChangeDataCardShop = (name, value) => ({
    type: 'CHANGE_DATA_CARD_SHOP', name, value
});